import { Box }                                                    from '@chakra-ui/react';
import { FILTER_WEBSITE_ENTERTAINMENT }                           from '@/constants';
import FondationsEntertainmentModel                               from '@/models/services/fondations/EntertainmentModel';
import PageContainer                                              from '@/components/pageContainer/PageContainer';
import PageTitle                                                  from '@/components/pageTitle/PageTitle';
import React                                                      from 'react';
import { SelectContent }                                          from '@/components/ui/select';
import { SelectItem }                                             from '@/components/ui/select';
import { SelectRoot }                                             from '@/components/ui/select';
import { SelectTrigger }                                          from '@/components/ui/select';
import { SelectValueText }                                        from '@/components/ui/select';
import Spinner                                                    from '@/components/spinner/Spinner';
import TicketsListBox                                             from './components/TicketsListBox';
import { createListCollection }                                   from '@chakra-ui/react';
import useApiCollection                                           from '@widesk-core/hooks/useApiCollection';
import useFetch                                                   from '@widesk-core/hooks/useFetch';
import { useTranslation }                                         from 'react-i18next';
import { getIdFromUrn }                                           from '@widesk-core/tools/identifier';
import EntertainmentModel                                         from '@/models/services/shop/EntertainmentModel';
import Modal                                                      from '@/components/modal/Modal';
import { ModalData }                                              from '@/components/modal/Modal';
import WebsiteEntertainmentModel                                  from '@/models/services/website/WebsiteEntertainmentModel';

const TicketsPage = () => {
	const { t } = useTranslation();

	const [modalData, setModalData] = React.useState<ModalData | undefined>();
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	const websiteEntertainmentCollection = useApiCollection(WebsiteEntertainmentModel);
	const entertainmentCollection = useApiCollection(FondationsEntertainmentModel);
	const shopEntertainmentCollection = useApiCollection(EntertainmentModel);
	const [selectedWebsiteEntertainment, setSelectedWebsiteEntertainment] = React.useState<WebsiteEntertainmentModel>();

	const { data: websiteEntertainments, isLoading } = useFetch(async () => {

		/* 
			Tâche JTSMC-63 => Sur la page qui liste les tickets, il faut lister uniquement les événements qui sont également présents sur le service Shop.
		*/
		const entertainmentFromShopUrns = (await shopEntertainmentCollection.list()).map(m => m.entertainmentUrn);
		await entertainmentCollection.setSort('dateStart', 'asc').setFilter('enabled', true).listBy(entertainmentFromShopUrns.map(urn => getIdFromUrn(urn)));
		await websiteEntertainmentCollection
			.setFilter('websiteEntertainmentStatus', '1')
			.setFilter('entertainmentUrn', entertainmentCollection.map(e => e.urn))
			.list();

		await websiteEntertainmentCollection.whenIsLoaded(we => we.website);

		const websiteEntertainmentUrn = (localStorage.getItem(FILTER_WEBSITE_ENTERTAINMENT) || '') as Urn;
		const websiteEntertainment = websiteEntertainmentCollection.getById(getIdFromUrn(websiteEntertainmentUrn));

		setSelectedWebsiteEntertainment(websiteEntertainment || websiteEntertainmentCollection.models[0]);

		return websiteEntertainmentCollection.models;
	}, true);

	const filterCollection = createListCollection({
		items: websiteEntertainments?.map(we => {
			return { label: we.label, value: we.urn }
		}) || [],
	});

	if (isLoading) {
		return <Spinner />
	}

	if (selectedWebsiteEntertainment) {
		return (
			<PageContainer>
				<Modal 
					model={modalData?.model}
					isDangerous={modalData?.isDangerous}
					isOpen={modalIsOpen}
					setIsOpen={setModalIsOpen}
					titleComponent={modalData?.titleComponent}
					bodyComponent={modalData?.bodyComponent}
					onConfirm={modalData?.onConfirm}
					onClose={modalData?.onClose}
					onSuccess={modalData?.onSuccess}
					onError={modalData?.onError}
				/>
				<Box
					display="flex"
					alignItems="center"
					justifyContent="space-between"
				>
					<PageTitle>
						{t('pages.tickets.label')}
					</PageTitle>
					<SelectRoot
						bg="white"
						borderRadius="xl"
						collection={filterCollection}
						size="sm"
						width="300px"
						onValueChange={(option) => {
							const value = option.value[0] as Urn;

							localStorage.setItem(FILTER_WEBSITE_ENTERTAINMENT, value);

							const websiteEntertainment = websiteEntertainmentCollection.getById(getIdFromUrn(value)) || undefined;

							setSelectedWebsiteEntertainment(websiteEntertainment);
						}}
						value={[selectedWebsiteEntertainment?.urn]}
					>
						<SelectTrigger>
							<SelectValueText />
						</SelectTrigger>
						<SelectContent>
							{filterCollection.items.map((entertainment) => (
								<SelectItem _hover={{ cursor: 'pointer', backgroundColor: '#DEDEDE' }} item={entertainment} key={entertainment.value}>
									{entertainment.label}
								</SelectItem>
							))}
						</SelectContent>
					</SelectRoot>
				</Box>
				<TicketsListBox websiteEntertainment={selectedWebsiteEntertainment} setModalData={setModalData} setModalIsOpen={setModalIsOpen} />
			</PageContainer>
		);
	}

	return <></>;
};

export default TicketsPage;